export default __webpack_public_path__ + "static/media/Asset 14.5e1c5499.png";